<forge-scaffold [ngClass]="scaffoldClasses">
  @if (showOmni) {
    <omni slot="header" [backBar]="false">
    </omni>
  }

  @if (!isModal) {
    <forge-drawer #leftMenu slot="body-left" role="navigation" direction="left" [open]="menuOpen"
      [tabindex]="leftMenuTabIndex" (forge-modal-drawer-close)="closeMenu()" class="navmenu">
      <app-menu></app-menu>
    </forge-drawer>
  } @else {
    @if (isModal) {
      <forge-modal-drawer #leftMenu slot="body-left" role="navigation" direction="left" [open]="menuOpen"
        [tabindex]="leftMenuTabIndex" (forge-modal-drawer-close)="closeMenu()" class="navmenu">
        <app-menu></app-menu>
      </forge-modal-drawer>
    }
  }

  <div slot="body" [ngClass]="{'embedded': embedded}" fxLayout="row" fxLayoutAlign="center" class="content" id="content" tabindex="-1" role="main" style="overflow: hidden;">
    <div fxFill>
      <router-outlet></router-outlet>
    </div>
  </div>


  @if (showAssistantFallback()) {
    <tyler-assistant-unavailable slot="body-right"></tyler-assistant-unavailable>
  }
</forge-scaffold>

